var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 0.515015,
    y: 0.611816,
    width: 54.8829,
    height: 54.8829,
    rx: 4,
    fill: "#142C4B",
    fillOpacity: 0.73
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 30H32.51M19 21V35C19 36.1046 19.8954 37 21 37H35C36.1046 37 37 36.1046 37 35V25C37 23.8954 36.1046 23 35 23L21 23C19.8954 23 19 22.1046 19 21ZM19 21C19 19.8954 19.8954 19 21 19H33M33 30C33 30.2761 32.7761 30.5 32.5 30.5C32.2239 30.5 32 30.2761 32 30C32 29.7239 32.2239 29.5 32.5 29.5C32.7761 29.5 33 29.7239 33 30Z",
    stroke: "#142C4B",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.70b552a126df8ee2186412da11af7181.svg";
export { ForwardRef as ReactComponent };